import { toast } from 'sonner';
import { createMutationHook } from '@/hooks/lib/createMutationHook';
import { apiPatch, operationsClient } from '@/lib/api';
import { estimateTemplateEndpoints } from '@/lib/api/endpoints';
import { estimateTemplateKeys } from '@/lib/queryKeys';
import type { EstimateTemplate, UpdateEstimateTemplateDto } from '@/types/estimateTemplate';

interface UpdateEstimateTemplateVars {
  id: string;
  dto: UpdateEstimateTemplateDto;
}

/**
 * Updates an existing estimate template via the operations microservice.
 */
export const useUpdateEstimateTemplate = createMutationHook<
  EstimateTemplate,
  UpdateEstimateTemplateVars
>({
  mutationFn: ({ id, dto }) =>
    apiPatch<EstimateTemplate, UpdateEstimateTemplateDto>(
      operationsClient,
      estimateTemplateEndpoints.update(id),
      dto,
    ),
  onSuccess: (_data, { id }, queryClient) => {
    void queryClient.invalidateQueries({ queryKey: estimateTemplateKeys.lists() });
    void queryClient.invalidateQueries({ queryKey: estimateTemplateKeys.detail(id) });
    toast.success('Template updated');
  },
});
